exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nestable-icon {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background-color: transparent;\n  background-position: center center;\n  background-repeat: no-repeat; }\n\n.nestable-icon:before {\n  content: '-';\n  display: inline-block;\n  width: 0;\n  height: 0;\n  overflow: hidden; }\n\n/* 20x20 */\n.icon-plus-gray {\n  width: 20px;\n  height: 20px;\n  background-image: url(" + require("./icon-plus-gray.svg") + "); }\n\n.icon-minus-gray {\n  width: 20px;\n  height: 20px;\n  background-image: url(" + require("./icon-minus-gray.svg") + "); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./~/react-nestable/dist/Icon/Icon.css
// module id = 1453
// module chunks = 0